<template>
    <div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Presolicitud</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row justify="center" v-if="loaded == false">
                            <v-col cols="12" md="7">
                                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-row justify="center" v-if="loaded && generales.length > 0">
                            <v-col cols="12" md="7">
                                <div>
                                    <span class="type-label-style">
                                        Proveedor:
                                    </span>
                                    <p class="type-text-style">{{generales[0].prnombre}}</p>
                                </div>
                                <v-divider class="mt-1"></v-divider>

                                <div>
                                    <span class="type-label-style">Concepto:</span>
                                    <p class="type-text-style">{{generales[0].psconcepto}}</p>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                                <div>
                                    <span class="type-label-style">Partidas:</span>
                                    <p class="type-text-style"></p>
                                    <v-col cols="12" md="6" offset-md="3">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th>Concepto</th>
                                                        <th>Monto</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="item in partidas" :key="item.id">
                                                        <td>{{item.concepto}}</td>
                                                        <td>{{item.monto}}</td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            {{total}}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                                <div>
                                    <span class="type-label-style">Observación:</span>
                                    <p class="type-text-style">{{generales[0].psobs}}</p>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                                <div>
                                    <v-form ref="form" v-model="valid" lazy-validation>
                                        <span class="type-label-style">Autorización:</span>
                                        <v-radio-group v-model="autorizacion" row :rules="[v => !!v || 'Opción requerida']" autofocus>
                                            <v-radio label="Si" style="text-align: center;"
                                                     value="1"></v-radio>
                                            <v-radio label="No" style="text-align: center;"
                                                     value="2"></v-radio>
                                        </v-radio-group>
                                    </v-form>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                                <div v-if="autorizacion == 1">
                                    <span class="type-label-style">Firma Electronica</span>
                                    <v-text-field outlined
                                                  dense
                                                  required
                                                  maxlength="17"
                                                  style="-webkit-text-security: disc;"
                                                  v-model="firma">
                                    </v-text-field>
                                    <span style="color: red;" v-show="validafirma">{{texto}}</span>
                                </div>
                                <div v-if="autorizacion == 2">
                                    <v-form ref="frm" v-model="valid2" lazy-validation>
                                        <span class="type-label-style">Observación</span>
                                        <v-textarea :counter="500"
                                                    :rules="rulestextarea"
                                                    outlined
                                                    v-model="observacion"
                                                    required
                                                    name="input-7-4"></v-textarea>
                                    </v-form>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center" v-if="loaded">
                                <v-btn class="ma-2"
                                       @click="Guardar()"
                                       color="primary">
                                    Guardar
                                </v-btn>
                                <v-btn class="ma-2" @click="Regresar()" color="error">
                                    Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="12">
                    <v-expansion-panels v-model="verhistorial"
                                        multiple>
                        <v-expansion-panel class="active-class" :key="0">
                            <v-expansion-panel-header class="card-title-text" style="min-height: 20px !important;" color="primary">Historial pago del reporte</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <br />
                                <DataTable :name="'Historial'"
                                           :url="urlpagoreporte"
                                           :columns="headpagoreporte"
                                           :params="displayInputs"
                                           :order="[]"
                                           @registro="NumRegistro"
                                           @apiDT="apiDT = $event">
                                </DataTable>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
            </v-col>
            <v-col cols="12" md="12">

                <v-expansion-panels v-model="vermp"
                                    multiple>
                    <v-expansion-panel class="active-class" :key="0">
                        <v-expansion-panel-header class="card-title-text" style="min-height: 20px !important;" color="primary">Reportes mismo MP o Localidad</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <br />
                            <DataTable :name="'MP'"
                                       :url="urlreportemp"
                                       :columns="headreportemp"
                                       :params="displayInputs"
                                       :order="[]"
                                       @Cancelar="CancelarShow"
                                       @registro="NumRegistro">
                            </DataTable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
               
            </v-col>
        </v-row>
</div>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import TramitePago from '@/services/TramitePago/TramitePago.Service.js';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
    import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable
        },
        data: function () {
            return {
                verhistorial: [0],
                loaded: false,
                vermp: [0],
                valid: true,
                valid2: true,
                showcargando: true,
                historial: [],
                reportemp: [],
                reporte: {},
                generales: [],
                partidas: [],
                header: [
                    { text: 'Concepto', value: 'concepto', class: 'text title' },
                    { text: 'Monto', value: 'monto', class: 'text title' },
                ],
                total: 0,
                autorizacion: 0,
                firma: '',
                validafirma: false,
                observacion: '',
                texto: '',
                rulestextarea: [
                    v => !!v || 'Campo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            if (v.length <= 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else if (v.length > 500) {
                                return 'Máximo 500 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                iniciarTabla: false,
                displayInputs: {
                    nrreporte: 0,
                    svindice: 0,
                },
                urlpagoreporte: 'TramitePago/HistorialPago',
                urlreportemp: 'TramitePago/ReportesmismoMP',
                headpagoreporte: [
                    { name: 'Concepto', data: 'Concepto', title: "Concepto" },
                    { name: 'Total', data: 'Total', title: "Total" },
                    { name: 'Abogado', data: 'Abogado', title: "Abogado" },
                    { name: 'Fechasolicitud', data: 'Fechasolicitud', title: "Fecha" },
                    { name: 'Estatus', data: 'Estatus', title: "Estatus" },
                ],
                headreportemp: [
                    { name: 'reporteind', data: 'reporteind', title: "Número de Reporte" },
                    { name: 'FechaReporte', data: 'FechaReporte', title: "Fecha" },
                    { name: 'Abogado', data: 'Abogado', title: "Abogado" },
                    { name: 'Estado', data: 'Estado', title: "Estado" },
                    { name: 'Localidad', data: 'Localidad', title: "Localidad" },
                    { name: 'MP', data: 'MP', title: "MP" },
                ],
                validapago: false,
                asistenciaurl: '',
            }
        },
        watch: {
            'firma': function () {
                if (this.firma != '')
                    this.validafirma = false;
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            NumRegistro(nombre, count) {
                if (count == 0) {
                    if (nombre == 'Historial')
                        this.verhistorial = [];
                    else if (nombre = 'MP')
                        this.vermp = [];
                }
            },
            async CancelarShow() {
                
                this.showcargando = false;

            },
            async DatosGenerales() {
                scroll(0, 100);
                let formdata = new FormData();
                formdata.append("reporte", this.reporte.nrreporte);
                formdata.append("indice", this.reporte.svindice);
                formdata.append("psid", this.reporte.psid);
                await TramitePago.DatosGenerales(this, formdata).then(data => {
                    this.generales = data;
                    this.total = MetodosGenerales.regresarValorMoneda(this.generales[0].pstotal, '$');
                    window.scrollTo(0, 0);
                });

                let psid = new FormData();
                psid.append("psid", this.reporte.psid);
                await TramitePago.Partidas(this, psid).then(data => {
                    this.partidas = data;
                });
                this.loaded = true;
            },
            Regresar() {
                this.$router.push({ path: this.asistenciaurl + '/Garantias' });
                //switch (this.reporte.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `GarantiasExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `GarantiasRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `GarantiasRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `GarantiasRCMedico` });
                //        break;
                //}
            },
            Guardar() {
               
                if (this.$refs.form.validate()) {
                    this.validafirma = false;
                    if (this.autorizacion == 1) {
                        if (this.firma == '') {
                            this.texto = 'Campo requerido';
                            this.validafirma = true;
                        }
                        else if (this.firma.length < 8) {
                            this.validafirma = true;
                            this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
                        }

                    }
                    
                    let formdata = new FormData();
                    formdata.append("psid", this.generales[0].psid);
                    formdata.append("respuesta", this.autorizacion);

                    if (this.validafirma == false && this.autorizacion == 1) {
                        
                        let firma = new FormData();
                        firma.append("usfirma", this.firma);
                        TramitePago.ValidaFirmaElectronica(this, firma).then(data => {
                            if (data) {
                                this.$swal({
                                    title: "Guardando los datos de autorización de la solicitud de pago...",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: false,
                                });
                                this.$swal.showLoading();
                                formdata.append("observacion", '');
                                TramitePago.GuardaAutorizacion(this, formdata).then(dato => {
                                    if (dato) {
                                        this.$swal({
                                            position: "center",
                                            icon: "success",
                                            title: "Éxito",
                                            text: "Movimiento de autorización guardado correctamente.",
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            showConfirmButton: true,
                                            timer: 4000,
                                        }).then(() => {
                                            this.$router.push({ path: this.asistenciaurl + '/Garantias' });
                                            //switch (this.reporte.aiclave.toString()) {
                                            //    case "1":
                                            //        this.$router.push({ name: `GarantiasExpJur` });
                                            //        break;
                                            //    case "24":
                                            //        this.$router.push({ name: `GarantiasRobo` });
                                            //        break;
                                            //    case "23":
                                            //        this.$router.push({ name: `GarantiasRLV` });
                                            //        break;
                                            //    case "5":
                                            //        this.$router.push({ name: `GarantiasRCMedico` });
                                            //        break;
                                            //}
                                        });
                                    }
                                    else {
                                        this.$swal({
                                            position: "center",
                                            icon: "error",
                                            title: "Error",
                                            text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            showConfirmButton: true,
                                            confirmButtonText: "Aceptar",
                                        });
                                    }
                                });
                            }
                            else {
                                this.validafirma = true;
                                this.texto = 'Firma electronica incorrecta';
                            }
                        });
                    }
                    else if (this.autorizacion == 2) {
                        this.observacion = this.observacion.trim();
                        this.observacion = this.observacion.replace(/\s*$/, "");
                        if (this.$refs.frm.validate() && this.observacion.length > 12) {
                            this.$swal({
                                title: "Guardando los datos de autorización de la solicitud de pago...",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: false,
                            });
                            formdata.append("observacion", this.observacion);
                            TramitePago.GuardaAutorizacion(this, formdata).then(data => {
                                if (data) {
                                    this.$swal({
                                        position: "center",
                                        icon: "success",
                                        title: "Éxito",
                                        text: "Movimiento de autorización guardado correctamente.",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: true,
                                        timer: 4000,
                                    }).then(() => {
                                        this.$router.push({ path: this.asistenciaurl + '/Garantias' });
                                        //switch (this.reporte.aiclave.toString()) {
                                        //    case "1":
                                        //        this.$router.push({ name: `GarantiasExpJur` });
                                        //        break;
                                        //    case "24":
                                        //        this.$router.push({ name: `GarantiasRobo` });
                                        //        break;
                                        //    case "23":
                                        //        this.$router.push({ name: `GarantiasRLV` });
                                        //        break;
                                        //    case "5":
                                        //        this.$router.push({ name: `GarantiasRCMedico` });
                                        //        break;
                                        //}
                                    });
                                }
                                else {
                                    this.$swal({
                                        position: "center",
                                        icon: "error",
                                        title: "Error",
                                        text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        showConfirmButton: true,
                                        confirmButtonText: "Aceptar",
                                    });
                                }
                            });
                        }
                    }
                }
            }
        },
        async mounted() {
            let permiso = false;
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '175').then(response => {
                if (response.data.length > 0) {
                    permiso = true;
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
            this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);
            //let formData = new FormData();
            //formData.append("nrreporte", this.reporte.nrreporte);
            //formData.append("svindice", this.reporte.svindice);
            //await Asistencia.ObtenerUrl(formData).then(data => {
            //    if (data.success == true) {
            //        this.asistenciaurl = data.result;
            //    }
            //    else
            //        this.asistenciaurl = '';
            //});
            if (permiso) {
                let nombre
                //this.$router.push({ path: this.asistenciaurl + '/Garantias2' });
                //switch (this.reporte.aiclave) {
                //    case 1:
                //        nombre = "GarantiasExpJur";
                //        break;
                //    case 5:
                //        nombre = "GarantiasRCMedico";
                //        break;
                //    case 23:
                //        nombre = "GarantiasRLV";
                //        break;
                //    case 24:
                //        nombre = "GarantiasRobo";
                //        break;
                //};
                //this.changeReporteMenuOption(nombre);
                this.changeReporteMenuOption("Garantías");
                let data = new FormData();
                data.append("reporte", this.reporte.nrreporte);
                data.append("indice", this.reporte.svindice);
                data.append("psid", this.reporte.psid);
                await this.DatosGenerales();
                await General.Autorizado(this, data).then(data => {
                    if (data == false) {
                        this.validapago = true;
                    }
                    else {
                        this.validapago = false;
                        this.$swal(
                            "Atención",
                            "La pre solicitud ya ha sido atendida",
                            "info"
                        );
                        this.$router.push({ name: 'index' });
                    }
                });
            }
            
        },
        async created() {
            if (window.sessionStorage.getItem("reporte") != null) {
                this.reporte = await MetodosGenerales.obtenerSessionReporte('reporte');

                this.displayInputs = {
                    nrreporte: this.reporte.nrreporte,
                    svindice: this.reporte.svindice,
                };
            }
        },
    }
</script>
<style scoped>
    .title-card-style {
        padding: 1.5px !important;
        max-height: auto;
    }

    .card-title-text {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1em;
        color: white;
    }

    .collapsable-container {
        background-color: white;
        height: 100% !important;
    }
    .type-label-style {
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        font-size: 12px;
    }

    .type-text-style {
        font-family: "Poppins", sans-serif;
        font-weight: 700;
        font-size: 1.3em;
    }

</style>